import { Injectable} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoggerService } from 'src/app/services/logger.service';
import { MatDialog } from '@angular/material';
import { DialogBaseComponent } from '../../dialogs/dialog-base/dialog-base.component';

@Injectable()
export class Interceptor implements HttpInterceptor {

   constructor(
      private router: Router,
      private logger: LoggerService,
      public dialog: MatDialog
   ) { }

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if (sessionStorage.getItem('tokenSession') != null) {
         this.logger.log('Entro al filter...', request.headers);
         const token = 'Bearer ' + sessionStorage.getItem('tokenSession');
         const headers = new HttpHeaders().set("Authorization", token);
         const authRequest = request.clone({ headers: headers });
         return next.handle(authRequest).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                sessionStorage.removeItem('infoCambioPass');
                sessionStorage.removeItem('currentUser');
                sessionStorage.clear();
                sessionStorage.removeItem('login');
                this.showDialog(
                  'Advertencia de Seguridad',
                  'Tu sesi&oacute;n ha sido cerrada por motivos de seguridad.<br>Ser&aacute;s redirigido al inicio de sesi&oacute;n.',
                  false
                );
                this.router.navigate(['']);
            }

            return throwError(err.status);
         }));
      } else {
         return next.handle(request);
      }
   }

   showDialog(pTitle: string, pContent: string, pShowBtnCancel: boolean) {
      const dialogRef = this.dialog.open(DialogBaseComponent, {
        data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel },
        disableClose: true
      });
  
      dialogRef.afterClosed().subscribe(result => {
        this.logger.log('The dialog was closed ' + result);
      });
    }
}